import { emailValidationRules } from '@validation/rules/account';
export const accountChangeEmailValidationRules = {
  newEmail: emailValidationRules
};